<template>
  <section class="commissions-inquire">
    <h2 class="commissions-inquire__title text-title">Commissions</h2>
    <p class="commissions-inquire__description text-description">
      Fill out the form below or contact Tom Grotta at
      <a
        class="commissions-inquire__description-link text-description"
        href="mailto:art@browngrotta.com"
      >
        art@browngrotta.com</a
      >.
    </p>
    <ValidationObserver
      class="commissions-inquire__form"
      v-slot="{ invalid }"
      tag="div"
      ref="observer"
    >
      <ValidationProvider
        tag="div"
        class="commissions-inquire__input"
        :rules="{ requiredSelect: true }"
        v-slot="{ errors }"
      >
        <BGASelect
          placeholder="Select Artist"
          v-model="form.artist"
          :selected="form.artist.id"
          :items="artists"
          :validateError="errors[0]"
          @input="form.artist = $event"
        ></BGASelect>
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="commissions-inquire__input"
        :rules="{ required: true, min: 2, max: 255 }"
        v-slot="{ errors }"
      >
        <SubscriptionInput
          class="form-control--inquire"
          placeholder="Your Name"
          v-model="form.name"
          :validateError="errors[0]"
        ></SubscriptionInput>
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="commissions-inquire__input"
        :rules="{ required: true, email: true, min: 2, max: 255 }"
        v-slot="{ errors }"
      >
        <SubscriptionInput
          class="form-control--inquire"
          placeholder="Email Address"
          v-model="form.email"
          :validateError="errors[0]"
        ></SubscriptionInput>
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="commissions-inquire__input"
        :rules="{ required: true, phone_number: true }"
        v-slot="{ errors }"
      >
        <SubscriptionInput
          class="form-control--inquire"
          placeholder="Phone Number"
          v-model="form.phone"
          :validateError="errors[0]"
        ></SubscriptionInput>
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="commissions-inquire__input"
        :rules="{ min: 2, max: 255 }"
        v-slot="{ errors }"
      >
        <SubscriptionInput
          class="form-control--inquire"
          placeholder="Location"
          v-model="form.service_location"
          :validateError="errors[0]"
        ></SubscriptionInput>
      </ValidationProvider>
      <!-- <div class="commissions-inquire__form-row">
        <ValidationProvider
          tag="div"
          class="commissions-inquire__input"
          :rules="{ required: true, number: true }"
          v-slot="{ errors }"
        >
          <SubscriptionInput
            class="form-control--inquire"
            placeholder="Height"
            v-model="form.height"
            :validateError="errors[0]"
          ></SubscriptionInput>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="commissions-inquire__input"
          :rules="{ required: true, number: true }"
          v-slot="{ errors }"
        >
          <SubscriptionInput
            class="form-control--inquire"
            placeholder="Width"
            v-model="form.width"
            :validateError="errors[0]"
          ></SubscriptionInput>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="commissions-inquire__input"
          :rules="{ required: true, number: true }"
          v-slot="{ errors }"
        >
          <SubscriptionInput
            class="form-control--inquire"
            placeholder="Length"
            v-model="form.length"
            :validateError="errors[0]"
          ></SubscriptionInput>
        </ValidationProvider>
      </div> -->
      <ValidationProvider tag="div" class="commissions-inquire__input">
        <DragAndDropFiles
          class="drag-and-drop--lg"
          placeholder="Upload image of proposed space"
          size="2"
          :file="form.files"
          @input="form.files = $event.files"
        ></DragAndDropFiles>
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="commissions-inquire__input"
        :rules="{ required: true, min: 2, max: 255 }"
        v-slot="{ errors }"
      >
        <BGATextarea
          class="form-control--inquire"
          placeholder="Describe features in the image (size of door, window frame, wall height and width)"
          v-model="form.description"
          :maxLength="255"
          :validateError="errors[0]"
        ></BGATextarea>
      </ValidationProvider>
      <BaseButton
        v-if="captchaVerifided"
        class="commissions-inquire__button button--white"
        text="SUBMIT"
        :disabled="invalid || submiting"
        @click="submit"
      ></BaseButton>
      <VueRecaptcha
        v-else
        ref="recaptcha"
        :sitekey="sitekey"
        @verify="captchaVerifided = true"
        @error="captchaVerifided = false"
      />
    </ValidationObserver>
  </section>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import BaseButton from "@/components/buttons/BaseButton.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import BaseCheckbox from "@/components/inputs/BaseCheckbox.vue";
import BGASelect from "@/components/inputs/BGASelect.vue";
import SubscriptionInput from "@/components/inputs/SubscriptionInput.vue";
import DragAndDropFiles from "@/components/DragAndDropFiles.vue";
import BGATextarea from "@/components/inputs/BGATextarea.vue";
import { VueRecaptcha } from "vue-recaptcha";

import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BaseButton,
    IconButton,
    BaseCheckbox,
    BGASelect,
    SubscriptionInput,
    DragAndDropFiles,
    BGATextarea,
    VueRecaptcha,
  },
  data() {
    return {
      captchaVerifided: false,
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      submiting: false,
      form: {
        artist: { id: null, title: "" },
        name: "",
        email: "",
        phone: "",
        service_location: "",
        // height: "",
        // width: "",
        // length: "",
        files: [],
        description: "",
      },
    };
  },
  head: {
    title: function () {
      return {
        inner: "Commissions browngrotta arts",
      };
    },
    meta: function () {
      return [
        {
          name: "description",
          itemprop: "description",
          content: "Commissions browngrotta arts",
          id: "meta:description",
        },
        {
          itemprop: "name",
          content: "Commissions browngrotta arts",
          id: "meta:name",
        },
        {
          itemprop: "image",
          content: `${process.env.VUE_APP_FRONTEND_URL}/img/icons/favicon-500x500.png`,
          id: "meta:image",
        },
        {
          property: "og:url",
          content: `${process.env.VUE_APP_FRONTEND_URL}${this.$route.path}`,
          id: "og:url",
        },
        {
          property: "og:type",
          content: "website",
          id: "og:type",
        },
        {
          property: "og:title",
          content: "Commissions browngrotta arts",
          id: "og:title",
        },
        {
          property: "og:image",
          content: `${process.env.VUE_APP_FRONTEND_URL}/img/icons/favicon-500x500.png`,
          id: "og:image",
        },
        {
          property: "og:image:alt",
          content: "Commissions browngrotta arts",
          id: "og:image:alt",
        },
        {
          property: "og:description",
          content: "Description Commissions browngrotta arts",
          id: "og:description",
        },
        {
          property: "og:site_name",
          content: process.env.VUE_APP_FRONTEND_URL,
          id: "og:site_name",
        },
        {
          property: "og:locale",
          content: "en_US",
          id: "og:locale",
        },
        {
          name: "twitter:card",
          content: "summary",
          id: "twitter:card",
        },
        {
          name: "twitter:site",
          content: "@BrowngrottaArts",
          id: "twitter:site",
        },
        {
          name: "twitter:creator",
          content: "@BrowngrottaArts",
          id: "twitter:creator",
        },
        {
          name: "twitter:url",
          content: `${process.env.VUE_APP_FRONTEND_URL}${this.$route.path}`,
          id: "twitter:url",
        },
        {
          name: "twitter:title",
          content: "Commissions browngrotta arts",
          id: "twitter:title",
        },
        {
          name: "twitter:description",
          content: "Description Commissions browngrotta arts",
          id: "twitter:description",
        },
        {
          name: "twitter:image",
          content: `${process.env.VUE_APP_FRONTEND_URL}/img/icons/favicon-500x500.png`,
          id: "twitter:image",
        },
        {
          name: "twitter:image:alt",
          content: "Commissions browngrotta arts",
          id: "twitter:image:alt",
        },
      ];
    },
  },
  computed: {
    ...mapGetters("publicapi/services", {
      artists: "getArtists",
    }),
  },
  async created() {
    const breadcrumbs = [
      {
        title: "Home",
        to: "/",
      },
      {
        title: "Commissions",
        to: "/art-advisory/commissions",
        clickable: true,
      },
      {
        title: "Inquire Commissions",
        to: "/art-advisory/commissions/inquire",
        clickable: false,
      },
    ];
    this.setBreadcrumbs(breadcrumbs);
    await this.apiGetArtists();
  },
  methods: {
    ...mapMutations(["setBreadcrumbs"]),
    ...mapActions("publicapi/services", ["apiFormsCommissions", "apiGetArtists"]),
    async submit() {
      this.submiting = true;
      let success = await this.apiFormsCommissions({
        artist: this.form.artist.title,
        name: this.form.name,
        email: this.form.email,
        phone: this.form.phone,
        service_location: this.form.service_location,
        // height: this.form.height,
        // width: this.form.width,
        // length: this.form.length,
        description: this.form.description,
        images: this.form.files,
      });
      if (success) {
        this.form.artist = { id: null, title: "" };
        this.form.name = "";
        this.form.email = "";
        this.form.phone = "";
        this.form.service_location = "";
        // this.form.height = "";
        // this.form.width = "";
        // this.form.length = "";
        this.form.description = "";
        this.form.files = [];
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      }
      this.submiting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.commissions-inquire {
  padding: 23rem 31.5rem 23rem;
  @media screen and (max-width: $xs) {
    padding: 27rem 25px 23rem;
  }
  &__title {
    font-size: 4rem;
    margin-bottom: 10px;
    text-align: center;
  }
  &__description {
    font-weight: 100;
    margin-bottom: 2.5rem;
    text-align: center;
    &-link {
      font-weight: 100;
      text-decoration: none;
    }
  }
  &__form {
    max-width: 39rem;
    margin: 0 auto;
    &-row {
      display: flex;
      .commissions-inquire__input {
        margin-right: 20px;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
  &__input {
    margin-bottom: 4.5rem;
  }
  &__button {
    min-width: 100%;
  }
  /* &__contacts {
    margin-top: 12rem;
  }
  &__sign-up {
    margin: 15rem auto 0;
    max-width: 60rem;
  } */
}
</style>
